module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_primaerlogo_pos.02f2c4bd.svg";